import React, { useEffect, useState } from "react";
import { formateDateTime } from "../../utils";
import Avatar from "../../static/images/Chat_icon.png";
import { ChatEvents, MessageType, Roles } from "../../constants";
import { createImageFromInitials } from "../../AgentLogo";
import FileIcon from "../../static/images/termlife_file_Icon.svg";
import DownloadIcon from "../../static/images/termlife_file_download_icon.svg";
import { TermPlanDetails } from "./PlanDetails";
import SearchGif from "../../static/images/search.gif";


function JsonTemplate({
    message,
    displayAllOptions,
    GAEvent,
    showPlansComparison,
    regenDoc,
    selectOption,
    contactSupport,
    mainMenu,
    ViewPlanDetails,
    scrollToBottom,
    agentName,
    roomClosed,
    haveAgentMsg,
    haveTermWaitingMsg
}) {
    
    const [viewMore, setViewMore] = useState(false)
    const content = JSON.parse(message.content);
    useEffect(() => {
        if (content.choices && content.choices.length > 4 && !message.selected) {
            setViewMore(true)
        }
    })
    const selectPlan=()=>{
        window.parent.postMessage({ message: 'Plan Selection.', planSelection: true }, '*');
    }
    // console.log(message.displayAllOptions)
    return (
        <>
            {content.type && (content.welcomeMsg == true || content.type.toLowerCase() === "agentwaitingmsg" || content.type.toLowerCase() === "postassignmenttermmsg") ?
                null
                :
                 <>{
                    message.name ?

                        <img class="grop_message usericon" src={createImageFromInitials(500, message.name, "blue")} />
                        :
                        <img class="grop_message usericon" src={Avatar} />
                } </>
                }
            {content.type && content.type.toLowerCase() === MessageType.document ?
                <div className="grop_message">
                    <div onClick={() => regenDoc(content.document.docId)} className="download-policy-message message">
                        <div className="download-policy">
                            <img src={FileIcon} className="icon-file" alt="" /> <p>Attachment</p> <img src={DownloadIcon} className="icon-download" alt="" />
                        </div>

                    </div>
                </div>
                : null}

            {content.type && content.type.toLowerCase() === "agentwaitingmsg" ?
                <>{agentName || roomClosed || haveAgentMsg || haveTermWaitingMsg ? null :
                    <div class="waitText">
                        {/* One of our trusted IRDAI-certified 🎖️ advisor will
                        assist you in few minutes. */}
                        <div>{content.title}</div>
                        
                        <div class="waitText_inner">
                            <span class="roundbox">
                                <img src={SearchGif} />
                            </span>
                            Stay connected on the chat screen
                        </div>
                    </div>}
                </> : null}

            {content.type && content.type.toLowerCase() === "postassignmenttermmsg" ?
                <>
                    {content.title ? (
                        <>
                            <div
                                class="postAssignmentTermMsg"
                                dangerouslySetInnerHTML={{ __html: content.title }}
                            />
                        </>
                    ) : null}
                </> : null}

            {content.type && content.type.toLowerCase() === "selection" ?
                <>
                    {content.title ? (
                        <>
                            <div class={`grop_message${content.welcomeMsg ? ' withWelcomeMsg' : ''}`}>
                                <div
                                    class="message"
                                    dangerouslySetInnerHTML={{ __html: content.title }}
                                />
                            </div>

                            {/* <img className="grop_message usericon" src={Avatar} alt=""></img> */}

                        </>
                    ) : null}
                    {message.selected ? null : (
                        <div class="grop_message tabq">

                            {content.choices.map((item1, index) => (
                                <>
                                    {message.displayAllOptions || index < 3 || !viewMore ?
                                        <div onClick={() => selectOption(item1, content.type, message.messageId)} class="question">
                                            {item1.display_value}
                                        </div>
                                        : null}
                                </>
                            ))}
                            {viewMore && !message.displayAllOptions ?

                                <div onClick={() => displayAllOptions(message.messageId)} class="question">
                                    {"View More"}
                                </div>

                                : null}
                            {content.welcomeMsg && content.isAgentWorkingHour ?
                                <div onClick={() => selectOption({ "display_value": "Chat with advisor instantly", "key": "CHAT_WITH_ADVISOR" }, content.type, message.messageId)} class="question advisor-btn" >
                                    <span class="lightning"></span>
                                    <span>Chat with our financial expert instantly</span>
                                </div> : null}

                        </div>
                    )}
                </>
                : null}
            {content.type && content.type.toLowerCase() === "plan_multi_selection" ?
                <>
                    {content.title ? (
                        <div class="grop_message">
                            <div
                                class="message"
                                dangerouslySetInnerHTML={{ __html: content.title }}
                            />
                        </div>
                    ) : null}

                </>
                : null}
            {content.type && content.type === "planSelection" ?
            <div className="grop_message" onClick={()=>selectPlan()}>
                <div class="message">Click below to buy Insurance
                    <br />
                    <a href={content.redirectionUrl} class="ref-cta btn" target="_blank">
                        Buy Insurance
                        <i class="redirection"></i>
                    </a>
                </div>
            </div>
                : null}


            {content.type && content.type === "list_plans" ?
                <>
                    {content.title ? (
                        <>
                            <div class="grop_message">
                                <div
                                    class="message"
                                    dangerouslySetInnerHTML={{ __html: content.title }}
                                />
                            </div>

                            {/* <img className="grop_message usericon" src={Avatar} alt=""></img> */}

                        </>
                    ) : null}

                    <TermPlanDetails message={message} ViewPlanDetails={ViewPlanDetails} contactSupport={contactSupport} mainMenu={mainMenu} content={content} selectOption={selectOption} scrollToBottom={scrollToBottom} />

                </>
                : null}
            {content.type && content.type === "CustomerEngage" ?
                <>
                    {message.selected ? null : content.choices.map((item1, index) => (
                        <div class="grop_message tabq" key={item1.key}>
                            <div onClick={() => selectOption(item1, "selection", message.messageId)} className="question " >
                                {item1.display_value}
                            </div>
                        </div>
                    ))}
                </>
                : null}
        </>
    );
}

export default function InvestmentAgentMessage({
    messages,
    agentName,
    displayAllOptions,
    GAEvent,
    showPlansComparison,
    regenDoc,
    selectOption,
    contactSupport,
    mainMenu,
    AgentMsg,
    ViewPlanDetails,
    scrollToBottom,
    roomClosed,
    haveAgentMsg,
    haveTermWaitingMsg
}) {
    const parseNewLine = (message) => {
        const formattedMessage = message.replace(/\n/g, '<br>');
        return formattedMessage
    }
    return (
        <li class="you">
            {messages.map((item) => (
                <>
                    {item.type.toLowerCase() === "json" ? (
                        <JsonTemplate
                            message={item}
                            displayAllOptions={displayAllOptions}
                            GAEvent={GAEvent}
                            showPlansComparison={showPlansComparison}
                            regenDoc={regenDoc}
                            selectOption={selectOption}
                            contactSupport={contactSupport}
                            mainMenu={mainMenu}
                            AgentMsg={AgentMsg}
                            ViewPlanDetails={ViewPlanDetails}
                            scrollToBottom={scrollToBottom}
                            agentName={agentName}
                            roomClosed={roomClosed}
                            haveAgentMsg={haveAgentMsg}
                            haveTermWaitingMsg={haveTermWaitingMsg}
                        ></JsonTemplate>
                    ) : (
                        <>
                        {/* {messages[messages.length - 1].name ?

                        <img class="grop_message usericon" src={createImageFromInitials(500, messages[messages.length - 1].name, "blue")} />
                        : */}
                                {item?.name ? (
                                    <div className="usericon initials_avatar">
                                        {item.name.split(" ").slice(0, 2).map(word => word[0].toUpperCase()).join("")}
                                    </div>
                                ) : (
                                    <img className="grop_message usericon" src={Avatar} />
                                )}
                                
                            <div class="grop_message">
                                <div
                                    class="message"
                                    dangerouslySetInnerHTML={{
                                        __html: parseNewLine(item.content),
                                    }}
                                >
                                    {" "}
                                </div>
                            </div>
                            {/* <img className="grop_message usericon" src={Avatar} alt=""></img> */}

                        </>
                    )}
                </>
            ))}
            {/* <div class="entete">
                <h3>{formateDateTime(messages[messages.length - 1].sentAt)}</h3>
            </div> */}
            {/* <div class="usericon"> 
                    <img src={Avatar} alt=""></img>
            </div> */}
        </li>
    );
}
